'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;

/**
 * MapSamurai Preloader - Manages loading states for map initialization
 */

var MapSamuraiPreloader = function () {
    function MapSamuraiPreloader($container) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, MapSamuraiPreloader);

        this.$container = $container;
        this.options = $.extend({
            stages: {
                'initializing': 'Initializing map...',
                'loading_tiles': 'Loading map tiles...',
                'loading_pins': 'Loading location pins...',
                'loading_clusters': 'Organizing clusters...',
                'loading_routes': 'Loading routes...',
                'loading_list': 'Preparing location list...',
                'loading_filters': 'Setting up filters...',
                'finalizing': 'Almost ready...'
            },
            timeout: 30000, // 30 second timeout
            showProgress: true,
            showStage: true,
            fadeOutDuration: 500
        }, options);

        this.loadingStates = {};
        this.currentStage = 'initializing';
        this.isComplete = false;
        this.hasError = false;
        this.startTime = Date.now();

        // Initialize loading states
        Object.keys(this.options.stages).forEach(function (stage) {
            _this.loadingStates[stage] = false;
        });

        this.init();
    }

    _createClass(MapSamuraiPreloader, [{
        key: 'init',
        value: function init() {
            this.createPreloaderHTML();
            this.setupTimeout();
            this.updateDisplay();

            // Add loading class to container
            this.$container.addClass('mpfy-loading');
        }
    }, {
        key: 'createPreloaderHTML',
        value: function createPreloaderHTML() {
            var preloaderHTML = '\n            <div class="mpfy-preloader">\n                <div class="mpfy-preloader-content">\n                    <div class="mpfy-preloader-text">Map Loading</div>\n                    <div class="mpfy-preloader-subtext">Please wait while we prepare the map</div>\n                    ' + (this.options.showProgress ? '<div class="mpfy-preloader-progress"><div class="mpfy-preloader-progress-bar"></div></div>' : '') + '\n                    ' + (this.options.showStage ? '<div class="mpfy-preloader-stage"></div>' : '') + '\n                </div>\n            </div>\n        ';

            this.$container.append(preloaderHTML);
            this.$preloader = this.$container.find('.mpfy-preloader');
            this.$progressBar = this.$container.find('.mpfy-preloader-progress-bar');
            this.$stage = this.$container.find('.mpfy-preloader-stage');
        }
    }, {
        key: 'setupTimeout',
        value: function setupTimeout() {
            var _this2 = this;

            this.timeoutTimer = setTimeout(function () {
                if (!_this2.isComplete) {
                    _this2.showError('Loading timeout. The map is taking longer than expected to load.');
                }
            }, this.options.timeout);
        }
    }, {
        key: 'setStage',
        value: function setStage(stage) {
            var progress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (this.isComplete || this.hasError) return;

            this.currentStage = stage;
            this.loadingStates[stage] = true;

            // Auto-calculate progress if not provided
            if (progress === null) {
                var completedStages = Object.values(this.loadingStates).filter(Boolean).length;
                var totalStages = Object.keys(this.loadingStates).length;
                progress = completedStages / totalStages * 100;
            }

            this.updateDisplay(progress);

            // Check if all stages are complete
            this.checkCompletion();
        }
    }, {
        key: 'updateDisplay',
        value: function updateDisplay() {
            var progress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (this.hasError) return;

            // Update stage text
            if (this.$stage.length && this.options.stages[this.currentStage]) {
                this.$stage.text(this.options.stages[this.currentStage]);
            }

            // Update progress bar
            if (this.$progressBar.length && progress !== null) {
                this.$progressBar.css('width', Math.min(100, progress) + '%');
            }
        }
    }, {
        key: 'checkCompletion',
        value: function checkCompletion() {
            var allComplete = Object.values(this.loadingStates).every(Boolean);

            if (allComplete && !this.isComplete) {
                this.complete();
            }
        }
    }, {
        key: 'complete',
        value: function complete() {
            var _this3 = this;

            if (this.isComplete || this.hasError) return;

            this.isComplete = true;
            this.clearTimeout();

            // Final progress update
            this.updateDisplay(100);
            this.$stage.text('Map loaded successfully!');

            // Remove loading class and add loaded class
            this.$container.removeClass('mpfy-loading').addClass('mpfy-loaded');

            // Fade out preloader
            setTimeout(function () {
                _this3.$preloader.addClass('mpfy-preloader-hidden');

                // Remove preloader after fade out
                setTimeout(function () {
                    _this3.$preloader.remove();
                    _this3.$container.trigger('mapsamurai.preloader.complete');
                }, _this3.options.fadeOutDuration);
            }, 500);
        }
    }, {
        key: 'showError',
        value: function showError(message) {
            var allowRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.isComplete) return;

            this.hasError = true;
            this.clearTimeout();

            this.$preloader.addClass('mpfy-preloader-error');
            this.$container.find('.mpfy-preloader-text').text('Loading Error');
            this.$container.find('.mpfy-preloader-subtext').text(message);
            this.$stage.text('Please try refreshing the page');

            if (allowRetry) {
                var $retryButton = $('<button class="mpfy-preloader-retry">Retry</button>');
                $retryButton.on('click', function () {
                    location.reload();
                });
                this.$container.find('.mpfy-preloader-content').append($retryButton);
            }

            this.$container.trigger('mapsamurai.preloader.error', { message: message });
        }
    }, {
        key: 'clearTimeout',
        value: function (_clearTimeout) {
            function clearTimeout() {
                return _clearTimeout.apply(this, arguments);
            }

            clearTimeout.toString = function () {
                return _clearTimeout.toString();
            };

            return clearTimeout;
        }(function () {
            if (this.timeoutTimer) {
                clearTimeout(this.timeoutTimer);
                this.timeoutTimer = null;
            }
        })

        // Utility methods for external use

    }, {
        key: 'getProgress',
        value: function getProgress() {
            var completedStages = Object.values(this.loadingStates).filter(Boolean).length;
            var totalStages = Object.keys(this.loadingStates).length;
            return completedStages / totalStages * 100;
        }
    }, {
        key: 'getCurrentStage',
        value: function getCurrentStage() {
            return this.currentStage;
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return !this.isComplete && !this.hasError;
        }

        // Static helper to create preloader promise

    }], [{
        key: 'createLoadingPromise',
        value: function createLoadingPromise(preloader, stage) {
            return new Promise(function (resolve, reject) {
                var timeout = setTimeout(function () {
                    reject(new Error('Stage ' + stage + ' timeout'));
                }, 10000); // 10 second per-stage timeout

                // Mark stage as complete when promise resolves
                var originalResolve = resolve;
                resolve = function resolve() {
                    clearTimeout(timeout);
                    preloader.setStage(stage);
                    originalResolve.apply(undefined, arguments);
                };

                // Handle rejection
                var originalReject = reject;
                reject = function reject(error) {
                    clearTimeout(timeout);
                    originalReject(error);
                };

                return { resolve: resolve, reject: reject };
            });
        }
    }]);

    return MapSamuraiPreloader;
}();

module.exports = MapSamuraiPreloader;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/preloader.js
// module id = 20
// module chunks = 0